// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListSlackWorkspaceInstallationsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ListSlackWorkspaceInstallationsQuery = { __typename?: 'Query' } & {
  listSlackWorkspaceInstallations: Array<
    { __typename?: 'EmployeeExternalAccountSlackWorkspace' } & Pick<
      Types.EmployeeExternalAccountSlackWorkspace,
      'teamId' | 'teamName'
    >
  >;
};

export const ListSlackWorkspaceInstallationsDocument = /*#__PURE__*/ gql`
    query listSlackWorkspaceInstallations {
  listSlackWorkspaceInstallations {
    teamId
    teamName
  }
}
    `;

/**
 * __useListSlackWorkspaceInstallationsQuery__
 *
 * To run a query within a React component, call `useListSlackWorkspaceInstallationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSlackWorkspaceInstallationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSlackWorkspaceInstallationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListSlackWorkspaceInstallationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListSlackWorkspaceInstallationsQuery,
    ListSlackWorkspaceInstallationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListSlackWorkspaceInstallationsQuery, ListSlackWorkspaceInstallationsQueryVariables>(
    ListSlackWorkspaceInstallationsDocument,
    options,
  );
}
export function useListSlackWorkspaceInstallationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListSlackWorkspaceInstallationsQuery,
    ListSlackWorkspaceInstallationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListSlackWorkspaceInstallationsQuery, ListSlackWorkspaceInstallationsQueryVariables>(
    ListSlackWorkspaceInstallationsDocument,
    options,
  );
}
// @ts-expect-error
export function useListSlackWorkspaceInstallationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListSlackWorkspaceInstallationsQuery,
    ListSlackWorkspaceInstallationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListSlackWorkspaceInstallationsQuery, ListSlackWorkspaceInstallationsQueryVariables>;
export function useListSlackWorkspaceInstallationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListSlackWorkspaceInstallationsQuery,
        ListSlackWorkspaceInstallationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListSlackWorkspaceInstallationsQuery | undefined,
  ListSlackWorkspaceInstallationsQueryVariables
>;
export function useListSlackWorkspaceInstallationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListSlackWorkspaceInstallationsQuery,
        ListSlackWorkspaceInstallationsQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListSlackWorkspaceInstallationsQuery, ListSlackWorkspaceInstallationsQueryVariables>(
    ListSlackWorkspaceInstallationsDocument,
    options,
  );
}
export type ListSlackWorkspaceInstallationsQueryHookResult = ReturnType<typeof useListSlackWorkspaceInstallationsQuery>;
export type ListSlackWorkspaceInstallationsLazyQueryHookResult = ReturnType<
  typeof useListSlackWorkspaceInstallationsLazyQuery
>;
export type ListSlackWorkspaceInstallationsSuspenseQueryHookResult = ReturnType<
  typeof useListSlackWorkspaceInstallationsSuspenseQuery
>;
